import { api_get, api_post, api_put, api_delete, PROYECT } from "services/api";
import {
  setSnackbar,
  startRequestComp,
  stopRequestComp,
} from "../search/searchActions.js";
import { policyManagmentTypes } from "redux/reducers/policyManagment/types.js";

const {
  HANDLE_POLICYMANAGMENTS_INPUTS,
  GET_POLICY,
  CREATE_POLICY,
  DELETE_POLICYMANAGMENT,
  GET_POLICY_NUMBER,
  ADD_MOVEMENT_TO_POLICY,
  EDIT_MOVEMENT_TO_POLICY,
  DELETE_MOVEMENT_TO_POLICY,
  GET_POLICY_ACCOUNTS,
  SEND_POLICY_TO_ORACLE,
  SET_NEW_POLICY,
} = policyManagmentTypes;
const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}`;
const mainUrl = `${baseUrl}/policy`;

export const handlePolicyManagmentsInputsAction = (key, value) => async (
  dispatch
) => {
  dispatch({ type: HANDLE_POLICYMANAGMENTS_INPUTS, payload: { key, value } });
};

export const newPolicy = () => async (dispatch) => {
  dispatch({ type: SET_NEW_POLICY });
  dispatch(setSnackbar("Formulario limpiado", "success"));
};

export const getPolicyManagmentsAction = (params) => async (dispatch) => {
  const { idCompany, idStation, policyNumber, date } = params;
  const url = `${mainUrl}/search/?idCompany=${idCompany}&idStation=${idStation}&number=${policyNumber}&date=${date}`;
  dispatch(startRequestComp("search"));
  try {
    const data = await api_get(url);

    dispatch({
      type: GET_POLICY,
      payload: data,
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("search"));
  }
};

export const createPolicyManagmentAction = (form) => async (dispatch) => {
  const { idCompany, idStation, date } = form;
  const url = `${mainUrl}?idCompany=${idCompany}&idStation=${idStation}`;
  dispatch(startRequestComp("createPolicy"));

  try {
    const data = await api_post(url, form);
    const url2 = `${mainUrl}_details/loadMovement/${data.id}`;
    const data2 = await api_post(url2, {
      idCompany,
      idStation,
      date,
    });
    dispatch({
      type: CREATE_POLICY,
      payload: {
        ...data,
        details: data2,
        status: "CREATE",
      },
    });
    dispatch(setSnackbar("Poliza creada correctamente", "success"));
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("createPolicy"));
  }
};

export const deletePolicyManagmentAction = (id) => async (dispatch) => {
  const url = `${mainUrl}/${id}/`;
  dispatch(startRequestComp("policyManagment"));
  try {
    await api_delete(url);
    dispatch({ type: DELETE_POLICYMANAGMENT });
    dispatch(setSnackbar("Poliza eliminada correctamente", "success"));
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("policyManagment"));
  }
};

export const getPolicyNumber = (idCompany, idStation, date) => async (
  dispatch
) => {
  const url = `${mainUrl}/getNumber?idCompany=${idCompany}&idStation=${idStation}&date=${date}`;
  dispatch(startRequestComp("getPolicyNumber"));
  try {
    const data = await api_get(url);
    dispatch({ type: GET_POLICY_NUMBER, payload: data?.nextNumber });
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("getPolicyNumber"));
  }
};

export const getPolicyAccountsAction = (id, openModal) => async (dispatch) => {
  const url = `${baseUrl}/accounting_account/${id}`;
  dispatch(startRequestComp("getPolicyAccounts"));
  try {
    const response = await api_get(url);
    dispatch({ type: GET_POLICY_ACCOUNTS, payload: response });
    openModal();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("getPolicyAccounts"));
  }
};

export const addMovementToPolicyAction = (form, close = () => {}) => async (
  dispatch
) => {
  const url = `${mainUrl}_details`;
  dispatch(startRequestComp("addMovementToPolicy"));
  try {
    const data = await api_post(url, form);
    dispatch({ type: ADD_MOVEMENT_TO_POLICY, payload: data });
    dispatch(setSnackbar("Movimiento agregado correctamente", "success"));
    close();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("addMovementToPolicy"));
  }
};

export const editMovementToPolicyAction = (
  id,
  form,
  close = () => {}
) => async (dispatch) => {
  const url = `${mainUrl}_details/${id}`;
  dispatch(startRequestComp("editMovementToPolicy"));
  try {
    await api_put(url, form);
    dispatch({
      type: EDIT_MOVEMENT_TO_POLICY,
      payload: { id, concept: form.concept },
    });
    dispatch(setSnackbar("Movimiento editado correctamente", "success"));
    close();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("editMovementToPolicy"));
  }
};

export const deleteMovementToPolicyAction = (
  id = null,
  idPolicy = null,
  close = () => {}
) => async (dispatch) => {
  const url = `${mainUrl}_details/${idPolicy ? idPolicy : id}`;
  dispatch(startRequestComp("deleteMovementToPolicy"));
  try {
    await api_delete(url);
    dispatch({ type: DELETE_MOVEMENT_TO_POLICY, payload: { idPolicy, id } });
    dispatch(setSnackbar("Movimiento eliminado correctamente", "success"));
    close();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("deleteMovementToPolicy"));
  }
};

export const sendPolicyToOracle = (id) => async (dispatch) => {
  const url = `${mainUrl}_details/erpinsert/${id}`;
  dispatch(startRequestComp("sendPolicyToOracle"));
  try {
    await api_post(url);
    dispatch({ type: SEND_POLICY_TO_ORACLE });
    dispatch(setSnackbar("Poliza enviada correctamente", "success"));
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("sendPolicyToOracle"));
  }
};
